import { estPreproduction } from '../lib/env'

/**
 * Bandeau d'avertissement, en haut de chaque page.
 *
 * L'application deployee pointe aujourd'hui vers le projet Supabase de TEST :
 * celui qui porte le schema tests_rls et des dossiers fabriques. C'est assume,
 * mais cela doit se voir a l'ecran, pas seulement dans un README que personne
 * n'ouvre pendant un rendez-vous.
 *
 * Il n'est pas refermable, et il part a l'impression : un rapport imprime depuis
 * cette instance ne doit pas pouvoir circuler sans sa mention.
 *
 * Couleurs : quasi-noir sur aplat orange vif, la seule combinaison que la charte
 * autorise sur cet orange (6,80:1, paire declaree dans PAIRES_CONTRASTE).
 */
export function BandeauEnvironnement() {
  if (!estPreproduction(import.meta.env)) return null

  return (
    <div
      role="status"
      data-test="bandeau-environnement"
      className="bg-marque-primaire px-4 py-2 text-center text-sm font-semibold uppercase tracking-wide text-marque-sur-primaire"
    >
      Préproduction — données de test
    </div>
  )
}
